import { PublicClientApplication } from "@azure/msal-browser";
import { mslConfig } from "./mslConfig";

const mslInstance = new PublicClientApplication(mslConfig);
export default mslInstance;
